<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-container>
      <h2 v-html="translatedText"></h2>

      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-label class="mr-4">E-Mail Adresse</v-label>
          <v-text-field
            v-model="email"
            variant="outlined"
            density="compact"
            :hide-details="true"
            placeholder="Deine E-Mail Adresse"
          />
        </v-col>

        <v-col>
          <v-btn
            variant="flat"
            size="large"
            color="primary"
            rounded="xl"
            class="white--text mb-2 find-favourites-button"
            :loading="saving"
            :disabled="saving || !email"
            @click="saveEmail"
          >
            {{ $t('entity.action.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { getCurrentInstance, ref, computed } from 'vue';

export default {
  setup() {
    const { proxy } = getCurrentInstance();

    const softToken = localStorage.getItem("softToken");
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");

    const translatedText = computed(() =>
      proxy.$t('settings.title', { username: proxy.$user.value?.username })
    );

    const email = ref(proxy.$user.value?.email ?? '');
    const saving = ref(false);

    const saveEmail = () => {
      if (!email.value) return;

      saving.value = true;

      proxy.$axios
        .put('/account/email', { email: email.value }, {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        })
        .then(() => {
          if (proxy.$user?.value) {
            proxy.$user.value.email = email.value;
          }
          proxy.$toast.success(proxy.$t('settings.messages.success'));
        })
        .catch((err) => {
          console.error('E-Mail Update fehlgeschlagen:', err);
          proxy.$toast.error(proxy.$t('settings.messages.error.fail'));
        })
        .finally(() => {
          saving.value = false;
        });
    };

    return {
      translatedText,
      email,
      saving,
      saveEmail,
    };
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  width: 900px;
}

.v-tab-selected {
  text-decoration: underline;
}

.v-tab {
  font-size: 26px;
  font-weight: 800;
  font-family: Montserrat, sans-serif;
  letter-spacing: normal;
}

.v-btn.find-favourites-button {
  font-size: 14px;
  font-weight: 400;
}
</style>
